/** Canonical configured options for labResults.nameOfLab; the field remains free-text compatible. */
export enum LabName {
  ALBUMIN = "Albumin",
  ALBUMIN_CREATININE_RATIO = "Albumin/Creatinine Ratio",
  ALDOSTERONE = "Aldosterone",
  ALDOSTERONE_RENIN_RATIO = "Aldosterone/Renin Ratio",
  ALKALINE_PHOSPHATASE = "Alkaline Phosphatase",
  ALT = "ALT",
  ANA = "ANA",
  ANCA = "ANCA",
  ANION_GAP = "Anion Gap",
  ANTI_DSDNA = "Anti-dsDNA",
  ANTI_GBM_ANTIBODY = "Anti-GBM Antibody",
  APTT = "aPTT",
  AST = "AST",
  BETA_2_MICROGLOBULIN = "Beta-2 Microglobulin",
  BNP = "BNP",
  BUN = "BUN",
  CALCIUM = "Calcium",
  CANCERGUARD = "Cancerguard",
  CBC = "CBC",
  CBC_WITH_DIFF = "CBC w/ Diff",
  CH50 = "CH50",
  COLOGUARD = "Cologuard",
  COMPLEMENT_C3 = "Complement C3",
  COMPLEMENT_C4 = "Complement C4",
  CREATININE = "Creatinine",
  CREATININE_CLEARANCE = "Creatinine Clearance",
  CRYOGLOBULIN = "Cryoglobulin",
  CYSTATIN_C = "Cystatin C",
  EGFR = "eGFR",
  ELECTROLYTES_PANEL = "Electrolytes Panel",
  FECAL_OCCULT_BLOOD_FIT_TEST = "Fecal occult blood / FIT test",
  FERRITIN = "Ferritin",
  FOLATE = "Folate",
  FREE_LIGHT_CHAINS = "Free Light Chains",
  FREE_METANEPHRINES = "Free Metanephrines",
  GLUCOSE = "Glucose",
  GONORRHEA_CHLAMYDIA = "Gonorrhea/chlamydia",
  HEPATITIS_B_CORE_ANTIBODY = "Hepatitis B Core Antibody",
  HEPATITIS_B_SURFACE_ANTIBODY = "Hepatitis B Surface Antibody",
  HEPATITIS_B_SURFACE_ANTIGEN = "Hepatitis B Surface Antigen",
  HEPATITIS_C_ANTIBODY = "Hepatitis C Antibody",
  HEPATITIS_C_SCREENING = "Hepatitis C screening",
  HGA1C = "HgA1c",
  HIV = "HIV",
  HPV_PAP = "HPV/Pap",
  HPV_TEST = "HPV test",
  IRON = "Iron",
  LIPIDS = "Lipids",
  MAGNESIUM = "Magnesium",
  METANEPHRINES = "Metanephrines",
  NT_PROBNP = "NT-proBNP",
  PAP_SMEAR = "Pap smear",
  PHOSPHORUS = "Phosphorus",
  PROTEIN_CREATININE_RATIO = "Protein/Creatinine Ratio",
  PT = "PT",
  PT_INR = "PT/INR",
  PTH_INTACT = "PTH, Intact",
  RENAL_FUNCTION_PANEL = "Renal Function Panel",
  RENIN = "Renin",
  SPEP = "SPEP",
  TIBC = "TIBC",
  TOTAL_BILIRUBIN = "Total Bilirubin",
  TOTAL_PROTEIN = "Total Protein",
  TSAT = "TSAT",
  TSH = "TSH",
  UPEP = "UPEP",
  URIC_ACID = "Uric Acid",
  URINALYSIS = "Urinalysis",
  URINALYSIS_WITH_REFLEX_CULTURE = "Urinalysis w/ Reflex Culture",
  URINE_CULTURE = "Urine Culture",
  VITAMIN_B12 = "Vitamin B12",
  VITAMIN_D_1_25_DIHYDROXY = "Vitamin D, 1,25-Dihydroxy",
  VITAMIN_D_25_HYDROXY = "Vitamin D, 25-Hydroxy",
}

/** Canonical values for the labResults.specimenType field. */
export enum LabSpecimenType {
  TWENTY_FOUR_HOUR_URINE = "24-Hour Urine",
  SERUM_OR_PLASMA = "Serum or Plasma",
  URINE = "Urine",
}
